"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
const BREAKPOINTS = {
  sm: 480,
  md: 768,
  lg: 1025,
  xl: 1440
};
const COLORS = {
  fuel: '#002d5b',
  shift: '#0082ff',
  'shift-hover': '#026bcf',
  accelerate: '#009851',
  go: '#1dbd71',
  caution: '#fdb22b',
  stop: '#ed3354',
  pavement: '#f6f7f9',
  dashboard: '#cbd4de',
  cement: '#5c7996',
  white: '#ffffff',
  black: '#212121',
  'social-behance': '#1769ff',
  'social-dribbble': '#ea4c89',
  'social-facebook': '#3b5998',
  'social-github': '#cccccc',
  'social-linkedin': '#007bb6',
  'social-twitter': '#00aced',
  'social-yelp': '#c41200'
};

/**
 * Utilities for working with common items from the SpotHero brand.
 * @module BrandUtils
 */
const BrandUtils = {
  /**
   * Gets the beginning size of the specified breakpoint.
   * @static
   * @function getBreakpoint
   * @param {String} size - The breakpoint to retrieve the size of. Possible values include 'sm', 'md', 'lg', and 'xl'.
   * @example
   * BrandUtils.getBreakpoint('sm');
   * @returns {Number} - The size of the breakpoint.
   */
  getBreakpoint(size) {
    if (!size || (0, _isUndefined.default)(BREAKPOINTS[size])) {
      throw new Error(`'${size}' is not a valid breakpoint name. Please use a defined name from the breakpoints available.`);
    }
    return BREAKPOINTS[size];
  },
  /**
   * Retrieves one of the specified brand colors.
   * @static
   * @function getColor
   * @param {String} name - The name of the color to retrieve the hex value for.
   * @example
   * BrandUtils.getColor('shift');
   * @returns {String} - The hexadecimal color value.
   */
  getColor(name) {
    if (!name || (0, _isUndefined.default)(COLORS[name])) {
      throw new Error(`'${name}' is not a valid color name. Please use a defined name from the colors available.`);
    }
    return COLORS[name];
  }
};
var _default = exports.default = BrandUtils;